// Celebration snackbar component
import { Snackbar, Alert } from '@mui/material';

const CelebrationSnackbar = ({ open, message, onClose }) => (
  <Snackbar
    open={open}
    autoHideDuration={4000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    sx={{ mt: 10, zIndex: 9998 }}
  >
    <Alert
      onClose={onClose}
      severity="success"
      variant="filled"
      sx={{
        width: '100%',
        borderRadius: 2,
        boxShadow: 3,
        fontWeight: 'bold',
        '& .MuiAlert-icon': { alignItems: 'center' },
      }}
    >
      {message}
    </Alert>
  </Snackbar>
);

export default CelebrationSnackbar;
